<template lang="html">
  <div class="sub-main column">
		<div v-if="advisor" class="sub-page column">
      <section class="details-bar column activity-container container-background">
        <div class='row container activity-container'>
          <div class='row avatar'>
            <div class='ctn-back' @click="goBack"><span class="icon-arrow-back" /></div>
            <!-- <div class='ctn-avatar'><img :src="advisor.picture" alt='' /></div> -->
            <div class='ctn-avatar' :style="{ backgroundImage: `url(${ advisor.picture })`}"></div>
            <div>
              <div class='bold details-bar-username'>{{advisor.first_name}} {{advisor.last_name}}</div>
              <div>{{advisor.roles[0] && advisor.roles[0] === "ROLE_ADVISOR" ? "Conseiller" : "Admin" }} chez <span class='bold'>{{advisor.office ? advisor.office : ''}}</span></div>
            </div>
          </div>
          <div class="row infos">
            <div class="column">
              <div class="label bold">E-MAIL</div>
              <div class="content">{{advisor.email}}</div>
            </div>
            <div class="column">
              <div class="label bold">TELEPHONE</div>
              <div class="content">{{advisor.phone}}</div>
            </div>
            <div class="column">
              <div class="label bold">ADRESSE</div>
              <div class="content">{{advisor.address}}</div>
            </div>
          </div>
          <div class="ctn-cta">
            <div class="btn btn-grey" @click="showAddConseiller = true">
              Editer
            </div>
            <div class='toggle'><toggle-input @change="updateConseillerStatus" :value="advisor.enabled" /></div>
          </div>
        </div>
      </section>
      <section class="take-place column activity-container container-background">
        <div class='header-table row'>
          <div class='title'>
            Liste des clients de {{advisor.first_name}} {{advisor.last_name}}
          </div>
        </div>
        <Table :elements="displayedClients" :clickable="true" @statuschange="updateClientStatus" />
        <baseModal :data="advisor" :show="showAddConseiller" @close="showAddConseiller = false" :content="contentModal" />
      </section>
		</div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import store from '@/store'
import { mapState } from 'vuex'
import ModalEditConseiller from '../modals/ConseillerModal'
import baseModal from '@/common/components/baseModal'
import Table from './ClientsTable'
export default {
	name: 'Conseillers',
	components: {
		Table,
		baseModal
	},
	data () {
		return {
			showAddConseiller: false,
			contentModal: ModalEditConseiller,
		}
	},
	beforeRouteEnter (to, from, next) {
		store.commit('LOADER_IN')
    store.dispatch('getConseillerById', to.params.id)
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
    methods: {
        goBack () {
            this.$router.push({ name: 'Conseillers' })
        },
        updateConseillerStatus (e) {
          console.log(e)
          const enable = e
          store.commit('LOADER_IN')
          if (enable) {
            this.$store.dispatch('enableConseiller', this.advisor.id)
            .finally(() => {
              store.commit('LOADER_OUT')
            })
          } else {
            this.$store.dispatch('disableConseiller', this.advisor.id)
            .finally(() => {
              store.commit('LOADER_OUT')
            })
          }
          // this.advisor.available = !this.advisor.available
          // this.$store.dispatch('editConseiller', this.advisor)
        },
        updateClientStatus (e) {
          const {value, rowIndex} = e
          const id = this.clients[rowIndex].user.id
          const enable = !value
          store.commit('LOADER_IN')
          if (enable) {
            this.$store.dispatch('enableAdvisorClient', id)
            .finally(() => {
              store.commit('LOADER_OUT')
            })
          } else {
            this.$store.dispatch('disableAdvisorClient', id)
            .finally(() => {
              store.commit('LOADER_OUT')
            })
          }
        }
    },
    computed: {
        displayedClients () {
            return this.clients.map(client => client.user)
        },
        ...mapState({
          advisor: state => state.conseillers.advisor,
          clients: state => state.conseillers.clients,
        })
    }
}
</script>



// WEBPACK FOOTER //
// Details.vue?32030d63